"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentPackages = void 0;
/* Package Imports */
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
/* Imported CSS */
require("@app/styles/PackageLists.scss");
/* Blast Imports */
var RecipientList_1 = require("./RecipientList");
var actions_1 = require("../state/actions");
var selectors_1 = require("../state/selectors");
var models_1 = require("@app/_state/models");
var LoadingIndicator_1 = require("@app/components/LoadingIndicator");
var PackageExpiration_1 = require("@app/components/packages/PackageExpiration");
var PackageFileSize_1 = require("@app/components/packages/PackageFileSize");
var actions_2 = require("@app/features/package-details/state/actions");
var SortHeader_1 = require("@app/features/package-history/components/SortHeader");
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var constants_2 = require("@server/shared/constants");
/**
 * Blast's Sent Packages component, displays all the packages in a user's outbox
 */
var SentPackages = /** @class */ (function (_super) {
    __extends(SentPackages, _super);
    function SentPackages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleLoadMore = function () {
            _this.props.onLoadMore(_this.props.pageSize, _this.props.searchTerm);
            new matomo_1.MatomoTracker().trackEvent('Sent Packages', 'Load More');
        };
        _this.handleOnPush = function () {
            _this.props.saveSearchTerm(_this.props.searchTerm ? _this.props.searchTerm : '');
        };
        _this.handleSort = function (sortKey) {
            _this.props.onSort(sortKey, _this.props.pageSize, _this.props.searchTerm);
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    SentPackages.prototype.componentDidMount = function () {
        this.props.onGetSentPackages(this.props.pageSize, this.props.searchTerm);
    };
    SentPackages.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.refreshPackages && prevProps.refreshPackages !== this.props.refreshPackages) {
            this.props.onUpdateCurrentOffset(0);
            this.props.onGetSentPackages(this.props.packages.length, this.props.searchTerm);
        }
        if (prevProps.searchTerm !== this.props.searchTerm ||
            prevProps.selectedUsers.length !== this.props.selectedUsers.length) {
            this.props.onUpdateCurrentOffset(0);
            this.props.onGetSentPackages(this.props.pageSize, this.props.searchTerm);
        }
    };
    /* Component Methods - End */
    SentPackages.prototype.render = function () {
        var _this = this;
        var _a = this.props, isSearching = _a.isSearching, sortKey = _a.sortKey, sortDirection = _a.sortDirection, hasMorePackages = _a.hasMorePackages, packages = _a.packages;
        var searchingPackagesTitle = react_1.default.createElement("h1", null, "Searching sent packages");
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "box sent-packages" },
                react_1.default.createElement("div", { className: "table sent-packages-table" },
                    react_1.default.createElement("div", { className: "columns header is-mobile" },
                        react_1.default.createElement("div", { className: "column is-0 th" }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-3 is-resize', text: "Subject", sortKey: constants_2.titleSortField, onClick: this.handleSort, currentSortKey: sortKey, currentSortDirection: sortDirection }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-1 is-variable', text: "Size", sortKey: constants_2.sizeSortField, onClick: this.handleSort, currentSortKey: sortKey, currentSortDirection: sortDirection }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-resize', text: "Sent", sortKey: constants_2.creationDateSortField, onClick: this.handleSort, currentSortKey: sortKey, currentSortDirection: sortDirection }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-variable', text: "Expires", sortKey: constants_2.expirationDateSortField, onClick: this.handleSort, currentSortKey: sortKey, currentSortDirection: sortDirection }),
                        react_1.default.createElement("div", { className: "column is-3 is-resize th" }, "Recipients")),
                    !isSearching && packages.map(function (p) { return (react_1.default.createElement(PackageDetailRow, { key: p.id, pkg: p, onPush: _this.handleOnPush })); }),
                    packages.length === 0 && !isSearching &&
                        react_1.default.createElement("div", { className: "columns is-mobile" },
                            react_1.default.createElement("div", { className: "column is-12 td" }, this.props.searchTerm && this.props.searchTerm !== '' ?
                                "No sent packages found while searching for \"" + this.props.searchTerm + "\"" :
                                'No recently sent packages...send something to build your history!'))),
                hasMorePackages &&
                    react_1.default.createElement("div", { className: "has-text-centered" },
                        react_1.default.createElement("button", { type: "button", className: "button is-primary", onClick: this.handleLoadMore }, "Load More"))),
            isSearching &&
                react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, { title: searchingPackagesTitle })));
    };
    return SentPackages;
}(react_1.Component));
exports.SentPackages = SentPackages;
var PackageDetailRow = function (props) {
    var pkg = props.pkg;
    var complete = react_1.default.createElement("span", { className: "delivery-status icon has-text-success tooltip is-tooltip-right", "data-tooltip": "Delivered." },
        react_1.default.createElement("i", { className: "fas fa-check-square fa-lg" }));
    var relay = react_1.default.createElement("span", { className: "delivery-status icon has-text-success tooltip is-tooltip-right", "data-tooltip": "Transferring to recipients." },
        react_1.default.createElement("i", { className: "fas fa-angle-double-right fa-lg" }));
    var verifyingPackageReceipt = react_1.default.createElement("span", { className: "delivery-status icon has-text-success tooltip is-tooltip-right", "data-tooltip": "Verifying package delivery." },
        react_1.default.createElement("i", { className: "fas fa-circle-notch fa-spin fa-lg" }));
    var uploading = react_1.default.createElement("span", { className: "delivery-status icon has-text-warning tooltip is-tooltip-right", "data-tooltip": "Uploading." },
        react_1.default.createElement("i", { className: "fas fa-circle-notch fa-spin fa-lg" }));
    var failed = react_1.default.createElement("span", { className: "delivery-status icon has-text-danger tooltip is-tooltip-right", "data-tooltip": "Failed to upload." },
        react_1.default.createElement("i", { className: "fas fa-ban fa-lg" }));
    var status = (pkg.pkgState !== models_1.PackageState.HELD) ? complete
        : ((pkg.totalBytes > 0 && !pkg.state) || (pkg.state && pkg.totalBytes > 0 && pkg.transferredBytes === pkg.totalBytes)) ? relay
            : (!pkg.state) ? verifyingPackageReceipt
                : (pkg.state === models_1.PackageTransferState.IN_PROGRESS) ? uploading : failed;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_device_detect_1.isMobile &&
            react_1.default.createElement("hr", null),
        react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/" + pkg.id, onClick: props.onPush },
            react_1.default.createElement("div", { className: "columns is-mobile" },
                react_1.default.createElement("div", { className: "column is-0 td is-variable" }, status),
                react_1.default.createElement("div", { className: "column is-3 td is-resize subject-title" },
                    pkg.encrypted &&
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-lock", title: "Password Protected" })),
                    pkg.title),
                react_1.default.createElement("div", { className: "column is-1 td is-variable" },
                    react_1.default.createElement(PackageFileSize_1.PackageFileSize, { size: pkg.totalBytes })),
                react_1.default.createElement("div", { className: "column is-2 td is-resize" },
                    react_1.default.createElement("span", { className: "tooltip sent-date", "data-tooltip": moment_1.default(pkg.creationDate).format(constants_1.DATE_TIME_FORMAT) }, moment_1.default(pkg.creationDate).format(constants_1.DATE_FORMAT))),
                react_1.default.createElement("div", { className: "column is-2 td is-variable" },
                    react_1.default.createElement(PackageExpiration_1.PackageExpiration, { expirationDate: (pkg.expirationDate === null) ? '' : pkg.expirationDate })),
                react_1.default.createElement("div", { className: "column is-3 td is-resize" },
                    react_1.default.createElement(RecipientList_1.RecipientList, { recipients: pkg.recipients, maxVisibleRecipients: 4, downloaders: pkg.downloaders }))))));
};
var mapStateToProps = function (store) {
    return {
        hasMorePackages: selectors_1.hasMoreSentPackages(store),
        isSearching: store.sentPackages.isSearching,
        packages: store.sentPackages.packages,
        refreshPackages: store.sentPackages.refreshPackages,
        selectedUsers: store.sentPackages.selectedUsers,
        sortKey: store.sentPackages.sortKey,
        sortDirection: store.sentPackages.sortDirection
    };
};
var mapDispatchToProps = {
    onGetSentPackages: actions_1.getSentPackages,
    onLoadMore: actions_1.loadMore,
    onSort: actions_1.sort,
    onUpdateCurrentOffset: actions_1.updateCurrentOffset,
    saveSearchTerm: actions_2.saveSearchTerm
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SentPackages);
